import { render } from "./BusTzFtLoadMaterialRecord.vue?vue&type=template&id=d6eee750&scoped=true"
import script from "./BusTzFtLoadMaterialRecord.vue?vue&type=script&lang=js"
export * from "./BusTzFtLoadMaterialRecord.vue?vue&type=script&lang=js"

import "./BusTzFtLoadMaterialRecord.vue?vue&type=style&index=0&id=d6eee750&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6eee750"]])

export default __exports__